import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  SkeletonDisplayText,
  SkeletonBodyText,
} from "@shopify/polaris";
import DataTableSkeleton from "components/datatable/DataTableSkeleton";

const SidebarCard = ({ lines }: { lines: number }) => (
  <Card roundedAbove="sm">
    <BlockStack gap="300">
      <SkeletonDisplayText size="small" />
      <SkeletonBodyText lines={lines} />
    </BlockStack>
  </Card>
);

/**
 * Loading placeholder for the fuel report detail page. Mirrors the real
 * two-column layout — the fuel-records and additional-expenses tables on the
 * left, the details card and the generate/sign flow cards on the right — so the
 * page doesn't jump once the report loads, instead of a bare full-page spinner.
 */
export default function FuelReportViewSkeleton() {
  return (
    <SkeletonPage fullWidth backAction primaryAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* fuel records table */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <DataTableSkeleton rows={5} columns={10} />
              </BlockStack>
            </Card>
            {/* additional expenses table */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <DataTableSkeleton rows={4} columns={9} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            {/* details */}
            <SidebarCard lines={9} />
            {/* generate report / sign flow cards */}
            <SidebarCard lines={3} />
            <SidebarCard lines={3} />
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
